import SosLinks from "./SosLinks";
import SosSearchInTab from "./SosSearchInTab";
import React from 'react'
import "./index.scss"
import AuthService from "tools/AuthService";

const SosTabContent = (props) => {
    const {creditCosts, updateSummaryCard} = props;
    const sosSearchEnabled = AuthService.getClientFeatures().sosSearchEnabled;
    const { isReadOnlyUser } = AuthService.getClientFeatures()

    return (<>
        {sosSearchEnabled && !isReadOnlyUser &&
            <SosSearchInTab creditCosts={creditCosts} updateSummaryCard={updateSummaryCard}/>
        }
        <SosLinks />
    </>)
}

export default SosTabContent;
